import dayjs, { ensureDayjsLocaleLoaded } from '@jpi-cloud-web-pro/jpi-cloud-shared/utils/dayjs';
import { timeFormatDefaultLocale } from 'd3-time-format';

import * as api from '@/api';

import { loadCultureByLanguage } from '@/localization/cultures';
import { reloadTranslations } from '@/text-db/actions';
import { saveLanguageSelectionToLocalStorage } from '@jpi-cloud-web-pro/jpi-cloud-shared/utils/getCultureByLanguage';

export const LANGUAGE_SELECTED = 'language/LANGUAGE_SELECTED';
export const selectLanguage = language => async (dispatch, getState) => {
  const culture = await loadCultureByLanguage(language);

  const { userInfo } = getState().app;

  timeFormatDefaultLocale(culture.d3TimeLocale);
  const loadedLocale = await ensureDayjsLocaleLoaded(culture.momentLocale);
  dayjs.locale(loadedLocale);

  if (userInfo?.id && !userInfo?.isDemo) {
    await api.updateUserLanguage(userInfo, culture.language);
  }

  dispatch(reloadTranslations(culture.language));

  dispatch({
    type: LANGUAGE_SELECTED,
    selectedLanguage: culture.language,
    languageTag: culture.languageTag,
  });

  saveLanguageSelectionToLocalStorage(culture.language);
};
